import { useQuery } from '@tanstack/react-query';
import { useAuthedFetch, parseJsonOrThrow } from './client';
import { StateResponse } from '../domain';

export function useStateQuery() {
  const fetcher = useAuthedFetch();
  return useQuery({
    queryKey: ['state'],
    queryFn: async () => {
      const res = await fetcher('/state');
      return parseJsonOrThrow(res, 'GET /state', (raw) => StateResponse.parse(raw));
    },
    refetchInterval: 10_000,
    staleTime: 5_000,
  });
}
